module.exports = __webpack_public_path__ + "img/AI分析-2.77125efb.png";